angular.module('tax_regime', ['ui.router','confirm.modal.html', 'ngResource', 'ngTable', 'ui.bootstrap']);

angular.module('tax_regime').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

    $stateProvider
    .state('tax_regime', {
        url         : "/tax_regime",
        templateUrl : server+"/views/m/tax_regime",
        controller  : 'tax_regime.list',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'home',
            label: 'Regime tributário'
        }
    })

    .state('tax_regime_create', {
        url         : "/tax_regime/create",
        templateUrl : server+"/views/m/tax_regime/create",
        controller  : 'tax_regime.create',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'tax_regime',
            label: 'Adicionar'
        }
    })

    .state('tax_regime_show', {
        url         : "/tax_regime/:id",
        templateUrl : server+"/views/m/tax_regime/show",
        controller  : 'tax_regime.show',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'tax_regime',
            label: '{{tax_regime.name}}'
        }
    })

}]);

/**
 * List Controller
 */
angular.module('tax_regime').
controller('tax_regime.list', ['$scope', '$http', '$auth', '$q', 'NgTableParams', '$tax_regime', function($scope, $http, $auth, $q, NgTableParams, $tax_regime) {
    $scope.tableParams = new NgTableParams({
        page: 1,
        count: 10
    }, {
        counts: [],
        filterDelay: 0,
        getData: function(params) {
            return $tax_regime.query(params.url()).$promise.then(function(data) {
                params.total(data.total);
                return data.data;
            });
        }
    });
}]);

/**
 * Create Controller
 */
angular.module('tax_regime').
controller('tax_regime.create', ['$scope', '$state', '$tax_regime', function($scope, $state, $tax_regime) {
    $scope.save = function() {
        $tax_regime.save($scope.tax_regime).$promise.then(function(data) {
            $state.go('tax_regime');
        });
    }
}]);

/**
 * Show, Edit, Delete Controller
 */
angular.module('tax_regime').
controller('tax_regime.show', ['$state', '$scope', '$stateParams', '$uibModal', '$tax_regime', function($state, $scope, $stateParams, $uibModal, $tax_regime) {

    $scope.editing = false;

    $scope.toggleEdit = function() {
        $scope.editing = !$scope.editing;
    }

    $tax_regime.get({
        id: $stateParams.id
    }).$promise.then(function(data) {
        $scope.tax_regime = data;
    }, function(error) {
        if (error.status == 404) {
            $state.go('notFound');
        }
    });

    $scope.confirmUpdate = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$scope', '$uibModalInstance', '$tax_regime', function($scope, $uibModalInstance, $tax_regime) {

                $scope.title = 'Deseja atualizar?';
                $scope.cancel_text = 'Cancelar';
                $scope.success_text = 'Concluído';

                var tax_regime = $scope.$parent.tax_regime;

                $scope.confirm = function() {
                    $tax_regime.update({
                        id: tax_regime.id
                    }, tax_regime).$promise.then(function(data) {
                        $uibModalInstance.dismiss('cancel');
                        $scope.$parent.toggleEdit();
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

    $scope.confirmDelete = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$state', '$scope', '$uibModalInstance', '$tax_regime', function($state, $scope, $uibModalInstance, $tax_regime) {

                $scope.title = 'Deseja remover esse registro?';
                $scope.cancel_text = 'Não';
                $scope.success_text = 'Sim';

                var tax_regime = $scope.$parent.tax_regime;

                $scope.confirm = function() {
                    $tax_regime.delete({id:tax_regime.id}).$promise.then(function(data){
                        $uibModalInstance.dismiss('cancel');
                        $state.go('tax_regime');
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

}]);


/**
 * Factory
 */
angular.module('tax_regime').
factory("$tax_regime", function($resource) {
    var resource = $resource(api + 'tax_regime/:id', null, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'update': {
            method: 'PUT'
        }
    });
    return resource;
});

angular.module("confirm.modal.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put('confirm.modal.html',
        '<div class="modal-body">' +
        ' {{title}}' +
        '</div>' +
        '<div class="modal-footer">' +
        '    <button class="btn btn-link btn-info" type="button" ng-click="cancel()">{{cancel_text}}</button>' +
        '    <button class="btn btn-outline btn-success" type="button" ng-click="confirm()">{{success_text}}</button>' +
        '</div>'
    );
}]);
